import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  rootSuccess: {
    flex: 0,
    flexDirection: 'row',
    backgroundColor: PALETTE.dawnBlue,
    borderColor: PALETTE.turquoiseGreen, 
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
  },
  iconType: {
    paddingRight: 20,
  },
  typeMessage: {
    justifyContent: 'center',
    flex: 0.9,
  },
  closeMark: {
    alignItems: 'flex-end',
    flex: 0.1,
  },
});